import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import { getCountriesLookup } from '@/services/country.service';
import FetchingSelect from '@/components/FetchingSelect';
import { CountryTypeStoryChapterTask, UpsertCountryTypeStoryChapterTask } from '@/models/story-chapter-task.model';

const modelSchema = Schema.Model<UpsertCountryTypeStoryChapterTask>({
  countryId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertCountryTypeStoryChapterTask = {
  countryId: undefined,
};

interface CountryTypeTaskFormFormProps{
  formObject?: CountryTypeStoryChapterTask;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
}

const CountryTypeTaskForm: React.FC<CountryTypeTaskFormFormProps> = ({ formObject, onFormChange, formRef, loading }) => {
  const [formValue, setFormValue] = useState<UpsertCountryTypeStoryChapterTask>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue(emptyModel);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-country-task-type' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:12}}>
            <Form.Group controlId="countryId">
              <Form.Label>Country</Form.Label>
              <Form.Control name="countryId" accepter={FetchingSelect} block
                fetchData={(text, page) => getCountriesLookup(text, page)} 
                placeholder="Select a Country"
                value={formValue.countryId}
                onChange={val=> setFormValue(pre => ({...pre, countryId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            User should run within a country. Amount: distance.
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default CountryTypeTaskForm;